import { render, staticRenderFns } from "./CardSistema.vue?vue&type=template&id=6acbf3b9&scoped=true"
import script from "./CardSistema.vue?vue&type=script&lang=ts"
export * from "./CardSistema.vue?vue&type=script&lang=ts"
import style0 from "./CardSistema.vue?vue&type=style&index=0&id=6acbf3b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acbf3b9",
  null
  
)

export default component.exports